var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"17","height":"14","viewBox":"0 0 17 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M13.8333 0L5.83333 8.4L3.16667 5.6L0.5 8.4L5.83333 14L16.5 2.8L13.8333 0Z","fill":"#09B78A"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }